import { getRootProps } from '@udecode/plate';
import cn from 'classnames';
import React from 'react';
import { useFocused, useSelected } from 'slate-react';

import { HrElementProps } from './HrElement.types';

export const HrElement = (props: HrElementProps) => {
  const { attributes, children, nodeProps } = props;

  const selected = useSelected();
  const focused = useFocused();
  const rootProps = getRootProps(props);

  return (
    <div {...attributes} {...rootProps} {...nodeProps}>
      <hr
        contentEditable={false}
        className={cn('cursor-pointer py-1 my-6 bg-clip-content border-none bg-gray-200 h-1', {
          ['bg-blue-500']: selected && focused,
        })}
      />
      {children}
    </div>
  );
};
